import { routes } from "@/constants/routes";
import { useTheme } from "@/theme/ThemeProvider";
import { AppButton } from "@/ui/components/AppButton";
import { Screen } from "@/ui/components/Screen";
import { EmptyState } from "@/ui/components/StateViews";
import { useRouter } from "expo-router";
import { Text, View } from "react-native";

export function OrgAccessDenied() {
  const { theme } = useTheme();
  const router = useRouter();

  return (
    <Screen title="Kein Zugriff" scroll>
      <EmptyState
        title="Kein Zugriff auf diesen Bereich"
        message="Diese Seite gehört zu keinem Verein, in dem du Mitglied bist – oder es gibt sie nicht."
      />
      <Text
        style={{
          color: theme.color.muted,
          textAlign: "center",
          marginBottom: theme.space.lg,
        }}
      >
        Wenn du glaubst, dass das ein Fehler ist, wende dich an die Administration deines Vereins.
      </Text>
      <View style={{ gap: theme.space.sm }}>
        <AppButton
          onPress={() => router.replace(routes.myClub as never)}
          style={{ minHeight: 44 }}
        >
          Zu meinem Verein
        </AppButton>
        <AppButton
          variant="secondary"
          onPress={() => router.replace(routes.home as never)}
          style={{ minHeight: 44 }}
        >
          Zum Control Board
        </AppButton>
      </View>
    </Screen>
  );
}

export function SuperadminReadOnlyBanner() {
  const { theme } = useTheme();
  const text =
    "Du siehst diesen Verein als Superadmin. Rollen und Status kannst du hier nicht ändern; Einladen ist möglich.";

  return (
    <View
      accessibilityRole="text"
      style={{
        paddingHorizontal: theme.space.lg,
        paddingVertical: theme.space.sm,
        backgroundColor: theme.color.infoBg,
        borderBottomWidth: 1,
        borderBottomColor: theme.color.info,
      }}
    >
      <Text style={{ color: theme.color.text, fontWeight: "600" }}>{text}</Text>
    </View>
  );
}
